import React from 'react';

import { CREDIT_MEMO } from 'components/pages/finance/NewInvoice/InvoiceTable/TableConstants';

import { stylesContent } from '../../EncounterInvoiceTemplateStyles';

export const SubItem = ({ item }) => {
  const reimbursementEventSuffix = item.reimbursementEventSuffix ? ` ${item.reimbursementEventSuffix}` : '';

  return (
    <div style={{ display: 'flex' }}>
      <div
        style={{ ...stylesContent.invoiceSubItem, width: [CREDIT_MEMO].includes(item.invoiceType) ? '281px' : '285px' }}
        className="row-item"
        data-testid="ledger-event-item"
      >
        {`${item.displayName || item.name}${reimbursementEventSuffix}`}
      </div>
      {!reimbursementEventSuffix && (
        <div style={{ width: '200px' }} data-testid="ledger-event-item-rate">
          {item.rate}
        </div>
      )}
      {item?.openBalance !== 0 && !reimbursementEventSuffix && <div>{item?.openBalanceString}</div>}
    </div>
  );
};
